<template>
    <Paper class='applianceCoefficient'>
        <m-panel
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :pageID="pageID"
            :verification="verification"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @saveData="saveData"
            @amend-btn="amendBtn"
            @check-btn="checkBtn"
            @del-btn="delBtn"
            @start-btn="startBtn"
            @stop-btn="stopBtn"
            searchId="bms_appliance_coefficient_query">
            <!-- 按钮区-->
            <div slot="table-module-btn">
                <div class="icon-button">
                    <el-tooltip class="item" effect="dark" content="新增" placement="bottom">
                        <el-button type='primary' size="mini" icon='el-icon-plus' @click="addData"></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="刷新" placement="bottom">
                        <el-button icon='el-icon-refresh' size="mini" @click="loadData" :loading="loading"></el-button>
                    </el-tooltip>
                </div>
            </div>
        </m-panel>
          <warning-dialog
            ref="AdmittRuleForm"
            :RwCarVisiable.sync="RwCarVisiable"
            v-if='RwCarVisiable'
            @handleRwCarClose="handleRwCarClose"
            @AdmittOk="AdmittOk"
            :dataLists='dataObj'
            :isButtonDisabled='isButtonDisabled'
            >
        </warning-dialog>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import mPanel from '@/components/otpPanel';
import config from './config.json';
import warningDialog from '../../../components/dialog/warningDialog.vue';
import lsrmapi from '../../../api/contract/warningConfigure';
export default {
    name: 'warningTask',
    data() {
        return {
            config: config,
            totalData: [],
            pageTotal: 100,
            editState: false,
            selectState: false,
            selectedRows: [],
            dataObj: {},
            loading: false,
            page: {
                pageSize: config.page.pageSize,
                pageNo: config.page.pageNo
            },
            searchQuery: {},
            pageID: 'lsrm_warning_configure',
            verification: {
                businessType: [{ required: true, message: ' ', trigger: 'change' }],
                companyName: [{ required: true, message: ' ', trigger: 'blur' }],
                sendPosition: [{ required: true, message: ' ', trigger: 'blur' }],
                warnDays: [{ required: true, message: ' ', trigger: 'blur' }]
            },
            hiddenEventType: [],
            RwCarVisiable: false,
            labelPosition: 'right',
            cellShaow: true,
            isButtonDisabled: false

        };
    },
    methods: {
        selectChange(data) {
            if (data.length > 0) {
                this.selectState = true;
                this.selectedRows = data;
            } else {
                this.selectState = false;
                this.selectedRows = [];
            }
        },
        searchChange(data) {
            this.page.pageNo = 1;
            this.searchQuery = data;
            this.loadData();
        },
        pageChange(data) {
            this.page.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            config.page.pageSize = this.page.pageSize = data;
            this.loadData();
        },
        addData() {
            this.dataObj = {};
            this.isButtonDisabled = false;
            this.RwCarVisiable = true;
        },
        amendBtn(data) {
            this.dataObj = data;
            this.isButtonDisabled = false;
            this.RwCarVisiable = true;
        },
        checkBtn(data) {
            this.dataObj = data;
            this.isButtonDisabled = true;
            this.RwCarVisiable = true;
        },
        delBtn(row) {
            const that = this;
            this.$confirm('是否删除这条数据?', '提示', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                lsrmapi.del(row.id).then(res => {
                    if (res) {
                        this.$message.success('删除成功！');
                        that.loadData();
                    }
                });
            });
        },
        startBtn(row) {
            this.changgeStatus(row, 1);
        },
        stopBtn(row) {
            this.changgeStatus(row, 0);
        },
        handleRwCarClose() { this.RwCarVisiable = false; },
        AdmittOk(data) {
            this.saveData(data);
        },
        saveData(data) {
            if (data.id) {
                lsrmapi.editSave(data, data.id).then(res => {
                    if (res) {
                        this.$message.success('修改成功！');
                        this.loadData();
                        this.RwCarVisiable = false;
                    }
                });
            } else {
                data.status = '1';
                lsrmapi.save(data).then(res => {
                    if (res) {
                        this.$message.success('新增成功！');
                        this.loadData();
                        this.RwCarVisiable = false;
                    }
                });
            }
        },
        delData() {
            const that = this;
            const datas = this.$refs.tablePage.$refs.table.selectedRowsData;
            if (datas.length > 0) {
                if (datas[0].status === 1 || datas[0].status === '是') {
                    this.$message.error('启动状态不可以删除！');
                    return;
                }
                lsrmapi.del(datas[0].id).then(res => {
                    if (res) {
                        this.$message.success('删除成功！');
                        that.loadData();
                    }
                });
            }
        },
        loadData() {
            this.loading = true;
            var params = {
                ...this.page,
                ...this.searchQuery
            };
            lsrmapi.get(params).then(res => {
                this.pageTotal = res.data.totalCount;
                this.totalData = res.data.list;
                for (let i = 0; i < this.totalData.length; i++) {
                    this.totalData[i].statusText = this.totalData[i].status === 0 ? '停用' : '启用';
                    this.totalData[i].status = String(this.totalData[i].status);
                    this.totalData[i].warnDays = String(this.totalData[i].warnDays);
                }
                var setHiddenEventMap = new Map();

                setHiddenEventMap
                    .set('0', this.hiddenEventType = [ 'check', 'stop' ])
                    .set('1', this.hiddenEventType = [ 'amend', 'del', 'start' ])
                    .set('null', this.hiddenEventType = [ 'check', 'stop' ]);
                this.totalData.forEach((subItem, subIndex) => {
                    subItem.hiddenEvent = this.hiddenEventType = setHiddenEventMap.get(subItem.status);
                });
                this.editState = false;
                this.loading = false;
            }).catch(res => {
                this.loading = false;
            });
        },
        changgeStatus(data, statusid) {
            if (statusid === 1) {
                data.status = 1;
            } else {
                data.status = 0;
            }
            lsrmapi.editStatus({
                status: data.status,
                version: data.version
            }, data.id).then(res => {
                if (res) {
                    this.$message.success('操作成功！');
                    this.loadData();
                }
            });
        }
    },
    created() {
        this.loadData();
    },
    components: { Paper, mPanel, warningDialog }
};
</script>
<!-- 样式区 -->
<style lang='less'>
    .applianceCoefficient {
      #advanced-search{
        padding-bottom: 0;
      }
    }
</style>
